import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import style from './SelectAllCheckbox.module.scss';

interface ISelectAllCheckbox {
	toggleSelectAllDevices: (value: boolean) => void;
	isAllDevicesSelected: boolean;
}

const SelectAllCheckbox: React.FC<ISelectAllCheckbox> = ({ isAllDevicesSelected, toggleSelectAllDevices }) => {
	const handleCheck = (e: CheckboxChangeEvent) => {
		toggleSelectAllDevices(e.target.checked);
	};

	return <Checkbox className={style.checkBoxElement} onChange={handleCheck} checked={isAllDevicesSelected} />;
};

export default React.memo(SelectAllCheckbox);
